import { Step } from "../types";

const steps : Step[] = [
  "mobile_verification",
  "email_verification",
  "pan_verification",
  "aadhaar_verification",
  "pan_image_upload",
  "personal_details",
  "bank_details",
  "liveliness_detection",
  "declaration",
  "signature",
  "nominee",
  "income_proof",
  "aadhaar_e_sign_documents",
  "e_sign_completed",
  "verification_pending",
  "verified",
  "re_verification",
  "modification",
  "user_setup",
  "completed",
]

const stepAndRouteMap: any = {
  mobile_verification: ['/login', '/verify-otp'],
  email_verification: ['/add-email', '/verify-email'],
  pan_verification: ['/verify-pan', '/change-dob'],
  pan_image_upload: ["/pan-image-upload"],
  aadhaar_verification: ['/kyc-verification'],
  personal_details: ['/personal-details'],
  bank_details: ['/link-bank-account'],
  liveliness_detection: ['/verify-image'],
  declaration: ['/sign-onboarding-form'],
  signature: ['/sign-onboarding-form'],
  nominee: ['/add-nominee'],
  income_proof: ['/add-income-details'],
  aadhaar_e_sign_documents: ['/aadhaar-esign'],
  e_sign_completed: ['/completed'],
  verified: ['/completed'],
  modification: ['/modification'],
  verification_pending: ['/completed'],
  user_setup: ['/completed'],
  completed: ['/completed'],
};

export { steps, stepAndRouteMap }
